import { gql } from '@biletiniz/apollo';

export const GET_USER = gql`
  query getUser {
    getUser {
      name
      surname
      email
      phoneNumber
      balance {
        amount
        currency
      }
    }
  }
`;
